import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrackets2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBrackets2"><Path fillRule="evenodd" clipRule="evenodd" d="M4 3H9V5H6V19H9V21H4V13H2V11H4V3ZM15 3H20V11H22V13H20V21H15V19H18V5H15V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBrackets2;
